import { Text } from "@mantine/core";
import { FC } from "react";
import { AcknowledgementLayout } from "@funded-here-interface/common";
import { useStyle } from "./SpvKycPending.styles";

const SpvKycPending: FC = () => {
  const { classes } = useStyle();

  return (
    <AcknowledgementLayout
      showLogo={false}
      content={
        <div className={classes.container}>
          <Text className={classes.headerText}>SPV KYC is Pending.</Text>
          <Text className={classes.text}>
            Our team is reviewing your SPV. We will get back to you as soon as
            possible via Email, so you can continue your journey with us.
          </Text>
          <Text className={classes.text}>Thank you for your patience.</Text>
        </div>
      }
    />
  );
};

export default SpvKycPending;
